import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faExclamationCircle, faExclamationTriangle, faInfoCircle, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useFlashBar } from '~/contexts/FlashBarContext';
import './FlashBar.css';

const ICONS = {
    success: faCheckCircle,
    error: faExclamationCircle,
    warning: faExclamationTriangle,
    info: faInfoCircle
};

const FlashBarItem = ({ flash, onDismiss }) => {
    return (
        <div className={`flash-bar flash-${flash.type}`}>
            <div className="flash-bar-content">
                <FontAwesomeIcon icon={ICONS[flash.type]} className="flash-icon" />
                <span className="flash-message">{flash.message}</span>
            </div>
            <button className="flash-close-btn" onClick={() => onDismiss(flash.id)}>
                <FontAwesomeIcon icon={faTimes} />
            </button>
        </div>
    );
};

export const FlashBarContainer = () => {
    const { flashes, dismissFlash } = useFlashBar();

    if (!flashes || flashes.length === 0) return null;

    return (
        <div className="flash-bar-container">
            {flashes.map(flash => (
                <FlashBarItem key={flash.id} flash={flash} onDismiss={dismissFlash} />
            ))}
        </div>
    );
};
